import React, { useState, useEffect, useCallback } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { Flex } from 'reflexbox'
import { useQuery} from '@apollo/react-hooks'
import { clientsQueries, demandsQueries } from '../../graphql/queries'
import Breadcumb from 'ui-components/lib/components/BreadCrumb'
import Table from 'ui-components/lib/components/Table'
import Pagination from 'ui-components/lib/components/Pagination'
import useSearchTerm from 'ui-components/lib/hooks/useSearchTerm'
import ChipStatusVariants from '../../components/ChipStatusVariants'
import HalfLoading from '../../components/HalfLoading'
import noDemandsPlaceholder from '../../images/placeholder-without-services.svg'
import { ReactComponent as Info } from '../../assets/icons/info.svg'
import InfoDemand from '../../components/Modal/InfoDemand'
import ApoioBonuz from "../../assets/icons/bonuz-apoio.svg"
import "./styles.css"
import {DefendantName} from "../../components";
import queryString from 'query-string'
import { shouldShowBrlForDemand, brlDisplayMultiplier } from '../../utils/demandPricingDisplay'

const Services = (props) => {
  const history = useHistory()
  const [sort, setSort] = useState('code')
  const [order, setOrder] = useState('desc')
  const [statusFilter, setStatusFilter] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [searchTerm, lazySearchTerm, { handleChangeSearchTerm }] = useSearchTerm('', 400)
  const [openInfoDemand, setOpenInfoDemand] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [demandId] = useState(0);
  const offset = 10
  const [statusUrl, setStatusUrl] = useState('');
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [showInfoTooltip, setShowInfoTooltip] = useState(false);

  const { data: dataStatus } = useQuery(clientsQueries.GET_STATUS)

  useEffect(() => {
    if (dataStatus && dataStatus?.me?.status === 'incomplete') {
      history.push('/completar-cadastro')
    }
  }, [dataStatus]) // eslint-disable-line

  const { loading: demandsLoading, data: demandsData, refetch: refetchDemands } = useQuery(demandsQueries.GET_DEMANDS, {
    variables: {
      search: lazySearchTerm,
      sort: sort,
      page: currentPage,
      order,
      offset,
      queryBy: 'status',
      query: statusFilter,
    },
  })

  const handleChangeOrder = (item) => {
    if (item.key === sort) {
      setOrder(order === 'asc' ? 'desc' : 'asc')
    } else {
      setSort(item.key)
      setOrder('asc')
    }
  }

  const handleChangeNext = () => {
    const nextPage = currentPage + 1
    if (nextPage <= demandsData?.listDemands?.pagination?.pagesAmount) {
      setCurrentPage(nextPage)
    }
  }

  const handleChangePrev = () => {
    const prevPage = currentPage - 1
    if (prevPage > 0) setCurrentPage(currentPage - 1)
  }

  const handleFilterChange = useCallback(
    (event) => {
      setStatusFilter(event.target.value)
    },
    [setStatusFilter]
  )

  useEffect(() => {
    refetchDemands()
  }, [refetchDemands, statusFilter, lazySearchTerm])

  useEffect(() => {
    const extrairParametro = () => {
      const queryParams = queryString.parse(props.location.search);
      const parametroValue = queryParams.status;
      setStatusUrl(parametroValue);
    };

    extrairParametro();
  }, [props.location.search]);

  useEffect(() => {
    setStatusFilter(statusUrl)
  }, [statusUrl])

  // Garantir que a página atual seja sempre visível em ambos os temas
  useEffect(() => {
    if (demandsLoading) return

    // Usar currentPage do estado ao invés de demandsData para evitar warning do ESLint
    const currentPageNumber = currentPage

    const ensureActivePageVisibility = () => {
      const paginationContainer = document.querySelector('.demands-pagination')
      if (!paginationContainer) return

      const buttons = paginationContainer.querySelectorAll('button')
      buttons.forEach(button => {
        // Ignorar botões de setas e ellipsis
        const buttonText = button.textContent?.trim()
        if (!buttonText || buttonText === '...' || buttonText === '‹' || buttonText === '›' || buttonText === '«' || buttonText === '»') {
          return
        }

        // Verificar se este botão representa a página atual
        const pageNumber = parseInt(buttonText, 10)
        const isCurrentPage = !isNaN(pageNumber) && pageNumber === currentPageNumber

        if (isCurrentPage) {
          button.classList.add('pagination-active-page')
          button.setAttribute('data-active', 'true')
          
          // Forçar texto branco diretamente com !important via setProperty
          button.style.setProperty('color', '#FFFFFF', 'important')
          button.style.setProperty('background-color', '#7683F6', 'important')
          button.style.setProperty('border-color', '#7683F6', 'important')
          button.style.setProperty('font-weight', '600', 'important')
          
          // Forçar texto branco em todos os elementos filhos
          const allChildren = button.querySelectorAll('*')
          allChildren.forEach(child => {
            child.style.setProperty('color', '#FFFFFF', 'important')
            if (child.tagName === 'SPAN') {
              child.style.setProperty('font-weight', '600', 'important')
            }
          })
          
          const span = button.querySelector('span')
          if (span) {
            span.style.setProperty('color', '#FFFFFF', 'important')
            span.style.setProperty('font-weight', '600', 'important')
          }
        } else {
          // Verificar também pelo background-color como fallback
          const computedStyle = window.getComputedStyle(button)
          const bgColor = computedStyle.backgroundColor
          const rgbMatch = bgColor.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/)
          
          let isPurple = false
          if (rgbMatch) {
            const r = parseInt(rgbMatch[1])
            const g = parseInt(rgbMatch[2])
            const b = parseInt(rgbMatch[3])
            isPurple = r >= 115 && r <= 121 && 
                       g >= 128 && g <= 134 && 
                       b >= 243 && b <= 249
          }
          
          if (isPurple && !isCurrentPage) {
            // Se tem background roxo mas não é a página atual, pode ser um problema de timing
            // Forçar mesmo assim para garantir visibilidade
            button.style.setProperty('color', '#FFFFFF', 'important')
            const span = button.querySelector('span')
            if (span) {
              span.style.setProperty('color', '#FFFFFF', 'important')
            }
          }
        }
      })
    }

    // Executar após renderização com múltiplos timeouts para garantir
    const timeoutId1 = setTimeout(ensureActivePageVisibility, 50)
    const timeoutId2 = setTimeout(ensureActivePageVisibility, 200)
    const timeoutId3 = setTimeout(ensureActivePageVisibility, 500)
    
    // Observar mudanças na paginação
    const observer = new MutationObserver(() => {
      setTimeout(ensureActivePageVisibility, 50)
    })
    const paginationContainer = document.querySelector('.demands-pagination')
    if (paginationContainer) {
      observer.observe(paginationContainer, { 
        childList: true, 
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      })
    }

    return () => {
      clearTimeout(timeoutId1)
      clearTimeout(timeoutId2)
      clearTimeout(timeoutId3)
      observer.disconnect()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, demandsLoading])

  const { push } = useHistory()

  const breadcrumbLinks = [
    { label: 'Início', onClick: () => push('/dashboard') },
    { label: 'Serviços', onClick: () => push('/dashboard/serviços') },
    { label: 'Demandas' },
  ]

  return (
    <>
      <Flex width={1} justifyContent="center" flexDirection="column" className="service">
        <Flex width={1} mb={3} className="breadCrumb">
          <Breadcumb ml={-3} color="primary" navigationLinks={breadcrumbLinks} />
        </Flex>
      </Flex>
      <div className="demands-page-container">
        <div className="demands-page-wrapper">
          <InfoDemand
            openModal={openInfoDemand}
            handleClose={() => setOpenInfoDemand(false)}
            id={demandId}
          />
          
          {/* Header Section */}
          <div className="demands-page-header">
            <div className="demands-header-content">
              <div>
                <h1 className="demands-page-title">Minhas Demandas</h1>
                <p className="demands-page-subtitle">
                  Visualize e gerencie todas as suas demandas de serviços jurídicos em um só lugar.
                </p>
              </div>
              <div className="demands-header-actions">
                <div 
                  className="demands-info-icon-compact"
                  onMouseEnter={() => setShowInfoTooltip(true)}
                  onMouseLeave={() => setShowInfoTooltip(false)}
                >
                  <Info className="demands-info-icon-small" />
                  {showInfoTooltip && (
                    <div className="demands-info-tooltip">
                      <strong>Informação importante:</strong> Caso encontre alguma divergência no serviço, você poderá solicitar uma revisão!
                    </div>
                  )}
                </div>
                <button 
                  className="demands-filters-toggle"
                  onClick={() => setFiltersOpen(!filtersOpen)}
                  type="button"
                >
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    width="16" 
                    height="16" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                    style={{ transform: filtersOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}
                  >
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                  <span>Filtros</span>
                </button>
              </div>
            </div>
          </div>

          {/* Collapsible Filters Section */}
          {filtersOpen && (
            <div className="demands-filters-section">
              <div className="demands-search-wrapper">
                <label className="demands-filter-label" htmlFor="search">Buscar demanda</label>
                <div className="demands-search-input-wrapper">
                  <svg 
                    className="demands-search-icon" 
                    xmlns="http://www.w3.org/2000/svg" 
                    width="20" 
                    height="20" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                  >
                    <circle cx="11" cy="11" r="8"></circle>
                    <path d="m21 21-4.35-4.35"></path>
                  </svg>
                  <input
                    id="search"
                    name="search"
                    type="text"
                    placeholder="Buscar por demanda..."
                    value={searchTerm}
                    onChange={(event) => handleChangeSearchTerm(event.target.value)}
                    className="demands-search-input"
                  />
                </div>
              </div>
              <div className="demands-filter-select-wrapper">
                <label className="demands-filter-label" htmlFor="status-filter">Filtrar por status</label>
                <select 
                  id="status-filter"
                  value={statusFilter} 
                  onChange={handleFilterChange}
                  className="demands-filter-select"
                >
                <option value="">Todos os status</option>
                <option value="pending">Pendente</option>
                <option value="in_progress">Em Progresso</option>
                <option value="stand_by">Standby</option>
                <option value="waiting_approval">Aguardando Aprovação</option>
                <option value="in_estimating">Aguardando Orçamento</option>
                <option value="draft">Pendente de informação</option>
                <option value="demand_sent">Demanda Enviada</option>
                <option value="in_review">Aguardando revisão</option>
                <option value="canceled">Cancelado</option>
                <option value="done">Concluído</option>
                <option value="waiting_estimate_approval">Aguardando aprovação de orçamento</option>
                <option value="waiting_lawyer_acceptance">Aguardando aceite do advogado</option>
              </select>
            </div>
          </div>
          )}
          {/* Table Section */}
          <div className="demands-table-container">
            {demandsLoading && <HalfLoading />}
            {!demandsLoading && demandsData?.listDemands?.data.length === 0 && (
              <div className="demands-empty-state">
                <h2 className="demands-empty-title">
                  {statusFilter || lazySearchTerm ? 'Nenhum serviço encontrado.' : 'Você ainda não solicitou nenhum serviço.'}
                </h2>
                <img className="demands-empty-image" src={noDemandsPlaceholder} alt="Nenhum serviço encontrado" />
              </div>
            )}
            {!demandsLoading && demandsData?.listDemands?.data.length !== 0 && (
              <div className="demands-table-wrapper">
                <Table
                  flex={1}
                  width={1}
                  onChangeOrder={handleChangeOrder}
                  loading={demandsLoading}
                  overflow={'auto'}
                  className="demand-table"
                  pagination={{
                    sort,
                    order,
                  }}
                  style={{ cursor: 'pointer' }}
                  headers={[
                    {
                      title: 'Número',
                      key: 'code',
                      sort: true,
                      align: 'left',
                      width: '30px',
                      cellComponent: ({ value, row }) => <Link to={`/dashboard/serviços/detalhes/${row._id}`} className="demand-number-link">{value.padStart(6, '0')}</Link>
                    },
                    {
                      title: 'Status',
                      key: 'status',
                      sort: true,
                      align: 'left',
                      width: '30px',
                      cellComponent: ({ value, row }) => <Link to={`/dashboard/serviços/detalhes/${row._id}`}><ChipStatusVariants style={{cursor: 'pointer'}} status={value} /></Link>,
                    },
                    {
                      title: 'Vencimento',
                      key: 'finalDate',
                      sort: true,
                      align: 'left',
                      width: '30px',
                      cellComponent: ({ value, row }) => <Link to={`/dashboard/serviços/detalhes/${row._id}`}>{
                        new Date(parseInt(value)).toLocaleDateString('pt-BR') === 'Invalid Date'?'Sem data definida':new Date(parseInt(value)).toLocaleDateString('pt-BR')}</Link>,
                    },
                    {
                      title: 'Demanda',
                      key: 'fullDescription',
                      sort: true,
                      align: 'left',
                      width: '300px',
                      cellComponent: ({ value, row }) => <Link to={`/dashboard/serviços/detalhes/${row._id}`} className="demand-description-link" title={value}>{value}</Link> || '-',
                    },
                    {
                      title: 'Demandado',
                      key: 'fullDescription',
                      sort: true,
                      align: 'left',
                      width: '180px',
                      cellComponent: ({ row }) => <Link to={`/dashboard/serviços/detalhes/${row._id}`} className="demand-text-link" title={row?.lawyer?.displayAs}>{row?.lawyer?.displayAs}</Link> || '-',
                    },
                    {
                      title: 'Demandante',
                      key: 'fullDescription',
                      sort: true,
                      align: 'left',
                      width: '180px',
                      cellComponent: ({ row }) => <Link to={`/dashboard/serviços/detalhes/${row._id}`} className="demand-text-link">{<DefendantName clientId={row.belongsToSubaccountId ?? row.clientId}/>}</Link> || '-',
                    },
                    {
                      title: 'Apoio Bonuz',
                      key: 'fullDescription',
                      sort: true,
                      align: 'center',
                      width: '35px',
                      cellComponent: ({ value, row }) => <Link to={`/dashboard/serviços/detalhes/${row._id}`}><img src={ApoioBonuz} alt="Apoio bonuz"/></Link> || '-',
                    },
                    {
                      title: 'Prazo',
                      key: 'deadline',
                      align: 'left',
                      width: '150px',
                      cellComponent: ({ value, row }) => value ? <Link to={`/dashboard/serviços/detalhes/${row._id}`}>{value}</Link>  : '-',
                    },
                    {
                        title: 'Valor',
                        key: 'price',
                        align: 'left',
                        width: '30px',
                        cellComponent: ({ value, row }) => {
                          if (value == null && value !== 0) return <Link to={`/dashboard/serviços/detalhes/${row._id}`}>-</Link>
                          const showBrl = shouldShowBrlForDemand({ status: row.status, isAuction: row.isAuction })
                          const display = showBrl
                            ? Number(value) * brlDisplayMultiplier(row.status)
                            : value
                          const suffix = showBrl ? ' R$' : ' BNZ'
                          return <Link to={`/dashboard/serviços/detalhes/${row._id}`}>{display}{suffix}</Link>
                        },
                      },
                    //   title: 'Avaliação',
                    //   key: 'status',
                    //   align: 'left',
                    //   cellComponent: ({ value, row }) => <ServiceEvaluation status={value} serviceId={row} lineId={row._id} />,
                    // },
                  ]}
                  data={demandsData?.listDemands?.data}
                />
              </div>
            )}
            {demandsData?.listDemands?.pagination?.pagesAmount > 1 && (
              <div className="demands-pagination">
                <Pagination
                  color="primary"
                  m={20}
                  onChangePage={(item) => setCurrentPage(item)}
                  onPrevPage={(item) => handleChangePrev()}
                  onNextPage={(item) => handleChangeNext()}
                  total={demandsData?.listDemands?.pagination?.pagesAmount}
                  page={demandsData?.listDemands?.pagination?.current || 1}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default Services
